module.exports = __webpack_public_path__ + "img/CI2.3d34133c.png";